import InventorNDAPanel from './InventorNDAPanel';

export default function InventorSchedule({ eventId, slots, connections, onRefresh }) {
  if (!slots?.length) {
    return (
      <div className="glass p-7">
        <h2 className="font-heading text-xl text-vault-navy mb-4">Your Pitch Schedule</h2>
        <p className="text-sm text-gray-400">Your confirmed pitch meetings will appear here.</p>
      </div>
    );
  }

  const sorted = [...slots].sort((a, b) => new Date(a.slot_start) - new Date(b.slot_start));

  const formatSlotTime = (start, end) => {
    const s = new Date(start);
    const e = new Date(end);
    const day = s.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    const startTime = s.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    const endTime = e.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    return `${day} · ${startTime} – ${endTime}`;
  };

  return (
    <div className="glass p-7">
      <h2 className="font-heading text-xl text-vault-navy mb-5">Your Pitch Schedule</h2>
      <div className="space-y-4">
        {sorted.map(slot => {
          const company = slot.company || {};
          const conn = (connections || []).find(c => c.company_id === slot.company_id);

          const statusConfig = {
            confirmed: { border: 'border-emerald-200', bg: 'bg-emerald-50', badge: 'bg-emerald-100 text-emerald-700', label: 'Confirmed' },
            booked_pending_nda: { border: 'border-amber-200', bg: 'bg-amber-50/30', badge: 'bg-amber-100 text-amber-700', label: 'Sign NDA to unlock Zoom' },
            cancelled: { border: 'border-gray-200', bg: 'bg-gray-50', badge: 'bg-gray-100 text-gray-400', label: 'Cancelled' },
            available: { border: 'border-vault-border', bg: 'bg-white', badge: 'bg-blue-100 text-blue-700', label: 'Available' },
          };
          const cfg = statusConfig[slot.status] || statusConfig.available;

          return (
            <div key={slot.id} className={`border-2 ${cfg.border} rounded-2xl p-5 ${cfg.bg}`}>
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-3">
                  {company.logo_url ? (
                    <img src={company.logo_url} alt="" className="w-10 h-10 rounded-btn object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-btn bg-indigo-100 flex items-center justify-center text-indigo-600 font-semibold text-sm">
                      {(company.company_name || '?').charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div>
                    <div className="font-semibold text-vault-navy text-sm">{company.company_name || 'Company'}</div>
                    <div className="text-xs text-gray-400 mt-0.5">{formatSlotTime(slot.slot_start, slot.slot_end)}</div>
                  </div>
                </div>
                <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold shrink-0 ${cfg.badge}`}>
                  {cfg.label}
                </span>
              </div>

              {slot.status === 'confirmed' && slot.zoom_link && (
                <div className="flex items-center gap-2 mt-3">
                  <a
                    href={slot.zoom_link}
                    target="_blank"
                    rel="noreferrer"
                    className="px-4 py-2 rounded-btn text-sm font-semibold text-white"
                    style={{ background: 'linear-gradient(135deg, #c9a84c, #F59E0B)' }}
                  >
                    Join Meeting
                  </a>
                </div>
              )}

              {slot.status === 'booked_pending_nda' && conn && (
                <InventorNDAPanel
                  connectionId={conn.id}
                  companyName={company.company_name || 'Company'}
                  companyNdaUrl={conn.company?.nda_document_url}
                  companyNdaLink={conn.company?.nda_link}
                  slot={slot}
                  onRefresh={onRefresh}
                />
              )}

              {slot.status === 'cancelled' && (
                <p className="text-xs text-gray-400 mt-1 line-through">This slot has been cancelled.</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
